// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createClaimHistory} from '../../shared/repositories';
import {getClaimHistoryReportCriteria} from '../../shared/services/reports';

export const createClaimHistoryReport = () =>
    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const claimHistoryReportState = getState().reports.claimHistory;

            const postArgs = getClaimHistoryReportCriteria(claimHistoryReportState);

            const data = await createClaimHistory(postArgs);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_CLAIM_HISTORY_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/claim-history/action-creators/report.js